<template>
<tr>
    <TableComponentInfo :componentId="componentId" ref="tblcomponent"></TableComponentInfo>
    <td  class="p18-75">
        {{ Running }}
    </td>
    <td  class="p18-75">
        {{ Completed }}
    </td>
    <td  class="OTborder-right p18-75">
        {{ Failed }}
    </td>
    <td  class="p18-75">
        {{ crawled }}
    </td>
   
    <td  class="p10 OTbadge OTbadgeDanger ErrorColor">
        <router-link :to="{name: 'events' , params: {isRoute:'true'}}">
            <span v-on:click="criticalFilter">{{ critical }}</span>
        </router-link>
        <!-- <router-link :to="{name: 'events' , params: {isRoute:'true'}}" :v-on="test">{{ critical }}</router-link> -->
    </td>
    <td  class="p10 OTbadge OTbadgeDanger ErrorColor">
        <!-- <router-link :to="{name: 'events' , params: {isRoute:'true'}}">{{ error }}</!--> 
        <router-link :to="{name: 'events' , params: {isRoute:'true'}}">
            <span v-on:click="errorFilter">{{ error }}</span>
        </router-link>
    </td>
    <td  class="p10 OTbadge OTbadgeSucces InfoColor">
        <!-- <router-link :to="{name: 'events' , params: {isRoute:'true'}}">{{ info }}</router-link> -->
        <router-link :to="{name: 'events' , params: {isRoute:'true'}}">
            <span v-on:click="infoFilter">{{ info }}</span>
        </router-link>
    </td>
    <td  class="p10 OTbadge OTbadgeWarning WarningColor">
        <!-- <router-link :to="{name: 'events' , params: {isRoute:'true'}}">{{ warning }}</router-link> -->
        <router-link :to="{name: 'events' , params: {isRoute:'true'}}">
            <span v-on:click="warningFilter">{{ warning }}</span>
        </router-link>
    </td>
    
 
</tr>
</template>

<script>

import TableComponentInfo from '../TableComponentInfo.vue';
import {mapDatums} from '../../../storeUtils/mapDatums.js';

export default {

    props: ['componentId'],

    components: {
        TableComponentInfo
    },

    computed: {
        ...mapDatums([
            'Running',
            'Completed',
            'pending',
            'Failed',
            'crawled',
            'info',
            'warning',
            'error',
            'critical'
        ])
    },
    mounted() {
        this.$parent.$on('show-extra-info', () => {
            this.$emit('show-extra-info');
        });
    },
    methods: {
        criticalFilter() {
            this.$store.state.facets.selectedFacets['L_ID'] = ['critical'];
            this.$store.state.facets.selectedFacets['S_ID'] = [this.getService(this.componentId)];
        },
        errorFilter() {
            this.$store.state.facets.selectedFacets['L_ID'] = ['error'];
            this.$store.state.facets.selectedFacets['S_ID'] = [this.getService(this.componentId)];
        },
        infoFilter() {
            this.$store.state.facets.selectedFacets['L_ID'] = ['info'];
            this.$store.state.facets.selectedFacets['S_ID'] = [this.getService(this.componentId)];
        },
        warningFilter() {
            this.$store.state.facets.selectedFacets['L_ID'] = ['warning'];
            this.$store.state.facets.selectedFacets['S_ID'] = [this.getService(this.componentId)];
        },
        getService(componentId) {
            var component = this.$store.state.components.components[componentId];
            return component.componentType;
        }
    }
}
</script>

